import createVuexHelper, { Helper } from './helpers/vuex';
export default createVuexHelper(Helper.Getters);
